import { render, staticRenderFns } from "./NotificationQueue.vue?vue&type=template&id=978f5e48&scoped=true&"
import script from "./NotificationQueue.vue?vue&type=script&lang=js&"
export * from "./NotificationQueue.vue?vue&type=script&lang=js&"
import style0 from "./NotificationQueue.vue?vue&type=style&index=0&id=978f5e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978f5e48",
  null
  
)

export default component.exports